import {
  APPLICATION_TAGS,
  DEVELOPER_HUB_GLOBAL_NAV_APP_NAME,
  SUPPORT_HUB_GLOBAL_NAV_APP_NAME,
} from '../constants/constants';

export const getApplicationTag = (route, sitecoreContext) =>
  route?.fields?.applicationTag?.value ||
  sitecoreContext?.route?.fields?.applicationTag?.value ||
  route?.applicationTag ||
  sitecoreContext?.route?.applicationTag;

export const isSupportApplication = (route, sitecoreContext) =>
  getApplicationTag(route, sitecoreContext) === APPLICATION_TAGS.SUPPORT;

export const getGlobalNavAppName = (route, sitecoreContext) =>
  isSupportApplication(route, sitecoreContext)
    ? SUPPORT_HUB_GLOBAL_NAV_APP_NAME
    : DEVELOPER_HUB_GLOBAL_NAV_APP_NAME;
